import { Component} from '@angular/core';;
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-embedded-form',
  standalone: false,
  templateUrl: './contact-specialist-embedded-form.component.html',
  styleUrl: './contact-specialist-embedded-form.component.scss'
})
export class ContactSpecialistEmbeddedFormComponent {
  protected contactSpecialistFormUrl: string = environment.urlContactSpecialistForm;
 
}
